import React from 'react';
import withRoot from '../../../withRoot';
import BaseGraph from '../base-graph'
import { horizontalBarDatasetOptions, horizontalBarOptions, horizontalBarPlugins } from '../constants'

class TSPModuleSfLChart extends React.Component {
  render() {
    return (
      <BaseGraph
        type='horizontalBar'
        tableTitle="Steps for Leaders by thematic module (number)"
        url='/graph/event_sfl'
        chartOptions={horizontalBarOptions('number')}
        datasetOptions={horizontalBarDatasetOptions}
        filter={this.props.filter}
        plugins={horizontalBarPlugins('number')}
        noActions={this.props.noActions}
      />
    )
  }
}

export default withRoot(TSPModuleSfLChart);
